const C = require("../constants");

const openModalOtherSales = modal => {
    return {
        type: C.OTHER_SALES_MODAL,
        modal
    }
};

export {openModalOtherSales};


// WEBPACK FOOTER //
// ./src/actions/ModalOtherSalesActions.js